import type { ValueOf } from 'type-fest'
import type { SlotProps, UseSlotProps } from 'src/components/Common/slot'
import { Slot, UseSlot } from 'src/components/Common/slot'

export const GrowthSlotName = {
  AppTopBanner: 'app-top-banner',
  AppLogo: 'app-logo',
  HomeBanner: 'home-banner',
  DailyClaimBottom: 'daily-claim-bottom',
  UserProfileMembershipButton: 'user-profile-membership-button',
} as const
export type GrowthSlotName = ValueOf<typeof GrowthSlotName>

export interface GrowthSlotProps extends SlotProps {
  name: GrowthSlotName
}

export function GrowthSlot(props: GrowthSlotProps) {
  return <Slot {...props} />
}

export interface UseGrowthSlotProps extends UseSlotProps {
  name: GrowthSlotName
}

export default function UseGrowthSlot(props: UseGrowthSlotProps) {
  return <UseSlot {...props} />
}
